import BasicTextInput from "components/BasicInputs/BasicTextInput";
import { useEffect, useState } from "react";

export interface TextProps {
  val: string;
  options?: any;
  row: any;
  colKey: string;
  onChange: (item: any, options?: any) => void;
  withBorder?: boolean;
}
export default function Text(props: TextProps) {
  const { val, options, colKey, row, withBorder } = props;
  const [value, setValue] = useState(!!val ? val : options && options.defaultValue);
  const [count, setCount] = useState(0);

  const deps: string[] = options?.deps || [];

  let changeOnBlur = true;
  if (options?.changeOnBlur !== undefined) changeOnBlur = !!options?.changeOnBlur;

  let onChange = props.onChange;
  if (options && options.onChange) onChange = options.onChange;

  useEffect(() => setCount((x) => x + 1), [...deps.map((x) => row[x])]);
  useEffect(() => setValue(props.val), [props.val]);

  function handleChange(val: string | number) {
    setValue(val);
    if (!changeOnBlur) {
      let res = { ...row };
      res[colKey] = val;
      onChange(res, { row });
    }
  }

  function handleBlur() {
    if (value !== val && changeOnBlur) {
      let res = { ...row };
      res[colKey] = value;
      onChange(res, { row });
    }
  }

  if (options) {
    return (
      <BasicTextInput
        key={count}
        type={options.type}
        inputStyle={{ WebkitTextFillColor: (options.type === "price") ? value > 0 ? "#18e131" : "red" : "" }}
        disabled={!options.editable}
        style={{ ...(!withBorder && { border: "none" }), ...props?.options?.style }}
        val={value}
        onChange={handleChange}
        onBlur={handleBlur}
      />
    );
  }
  return <div>{value}</div>;
}
